import { ICreateEntityFailureActionPayload } from 'app/projects/entity/src/lib/interfaces/create-entity-failure-payload.interface';
import { IFetchEntityFailureActionPayload } from 'app/projects/entity/src/lib/interfaces/fetch-entity-failure-payload.interface';
import { IUpdateEntityFailureActionPayload } from 'app/projects/entity/src/lib/interfaces/update-entity-failure-payload.interface';
import { PerformancePeriod } from '../models/performance-period.model';
import { ICreatePerformancePeriodActionPayload } from '../interfaces/create-performance-period.action.payload.interface';

export class SetPerformancePeriod {
    static readonly type = '[PerformancePeriod] SetPerformancePeriod';

    constructor(public payload: PerformancePeriod) {}
}

export class UnsetPerformancePeriod {
    static readonly type = '[PerformancePeriod] UnsetPerformancePeriod';
}

export class FetchPerformancePeriod {
    static readonly type = '[PerformancePeriod] FetchPerformancePeriod';

    constructor(public payload: string) {}
}

export class FetchPerformancePeriodSuccess {
    static readonly type = '[PerformancePeriod] FetchPerformancePeriodSuccess';

    constructor(public payload: PerformancePeriod) {}
}

export class FetchPerformancePeriodFailure {
    static readonly type = '[PerformancePeriod] FetchPerformancePeriodFailure';

    constructor(public payload: IFetchEntityFailureActionPayload) {}
}

export class CreatePerformancePeriod {
    static readonly type = '[PerformancePeriod] CreatePerformancePeriod';

    constructor(public payload: ICreatePerformancePeriodActionPayload) {}
}

export class CreatePerformancePeriodSuccess {
    static readonly type = '[PerformancePeriod] CreatePerformancePeriodSuccess';

    constructor(public payload: PerformancePeriod) {}
}

export class CreatePerformancePeriodFailure {
    static readonly type = '[PerformancePeriod] CreatePerformancePeriodFailure';

    constructor(public payload: ICreateEntityFailureActionPayload) {}
}

export class UpdatePerformancePeriod {
    static readonly type = '[PerformancePeriod] UpdatePerformancePeriod';

    constructor(public payload: PerformancePeriod) {}
}

export class UpdatePerformancePeriodSuccess {
    static readonly type = '[PerformancePeriod] UpdatePerformancePeriodSuccess';

    constructor(public payload: PerformancePeriod) {}
}

export class UpdatePerformancePeriodFailure {
    static readonly type = '[PerformancePeriod] UpdatePerformancePeriodFailure';

    constructor(public payload: IUpdateEntityFailureActionPayload) {}
}

export class DeletePerformancePeriod {
    static readonly type = '[PerformancePeriod] DeletePerformancePeriod';

    constructor(public payload: string) {}
}

export class DeletePerformancePeriodSuccess {
    static readonly type = '[PerformancePeriod] DeletePerformancePeriodSuccess';

    constructor(public payload: string) {}
}

export class DeletePerformancePeriodFailure {
    static readonly type = '[PerformancePeriod] DeletePerformancePeriodFailure';

    constructor(public payload: string) {}
}

export class SetPerformancePeriods {
    static readonly type = '[PerformancePeriod] SetPerformancePeriods';

    constructor(public payload: PerformancePeriod[]) {}
}

export class FetchPerformancePeriods {
    static readonly type = '[PerformancePeriod] FetchPerformancePeriods';

    constructor(
        public payload?: {
            pageSize: number;
            pageNumber: number;
            sortBy: string;
        }
    ) {}
}

export class FetchPerformancePeriodsSuccess {
    static readonly type = '[PerformancePeriod] FetchPerformancePeriodsSuccess';

    constructor(public payload: PerformancePeriod[]) {}
}

export class FetchPerformancePeriodsFailure {
    static readonly type = '[PerformancePeriod] FetchPerformancePeriodsFailure';
}

export class ToggleSelectedPerformancePeriod {
    static readonly type = '[PerformancePeriod] ToggleSelectedPerformancePeriod';

    constructor(public payload: string) {}
}

export class SelectFilteredPerformancePeriods {
    static readonly type = '[PerformancePeriod] SelectFilteredPerformancePeriods';
}

export class DeselectSelectedPerformancePeriods {
    static readonly type = '[PerformancePeriod] DeselectSelectedPerformancePeriods';
}

export class SearchPerformancePeriods {
    static readonly type = '[PerformancePeriod] SearchPerformancePeriods';

    constructor(public payload: string) {}
}
